<template>
  <!-- 头部 -->
  <div class="report-summary" @click="showInfoModal = false">
    <div class="report-content">
      <div class="report-text" :class="{ 'english-layout': $i18n.locale === 'en-US' }">
        <div class="report-title" :class="{ 'english-title': $i18n.locale === 'en-US' }">{{ $t('titles.bodyHealthInfo') }}</div>
        <div class="report-subtitle" :class="{ 'english-subtitle': $i18n.locale === 'en-US' }">{{ $t('titles.comprehensiveDataReport') }}</div>
        <div class="report-title-2">{{ $t('titles.dataDisclaimer') }}</div>
      </div>
      <div class="report-image">
        <img src="../assets//插画-评估报告@2x.png" :alt="$t('titles.healthReport')" />
      </div>
    </div>
    <div class="body-title">
      {{ $t('titles.constitutionAssessment') }}
      <img 
        src="../assets/Info_icon.png" 
        alt="info" 
        class="info-icon" 
@click.stop="showInfoModal = !showInfoModal"
      />
    </div>
    
    <!-- 信息图片 -->
    <img 
      v-if="showInfoModal"
      :src="$i18n.locale === 'en-US' ? require('../assets/En_window.png') : require('../assets/Ch_window.png')"
      alt="info"
      class="info-image"
      @click.stop
    />
    <div class="tabs-container">
      <div v-if="false"
        class="tab-item"
        :class="{ active: activeTab === 'nutrition' }"
        @click="activeTab = 'nutrition'"
      >
        {{ $t('titles.nutritionAssessment') }}
      </div>
      <div v-if="false"
        class="tab-item"
        :class="{ active: activeTab === 'constitution' }"
        @click="activeTab = 'constitution'"
      >
        {{ $t('titles.constitutionEvaluation') }}
      </div>
      <div v-if="false"
        class="tab-item"
        :class="{ active: activeTab === 'body' }"
        @click="activeTab = 'body'"
      >
        {{ $t('titles.bodyAssessment') }}
      </div>
    </div>
    <!-- 营养素评估内容 -->
    <div v-if="activeTab === 'nutrition'" class="chart-section">
      <!-- 状态图 -->
      <!-- <waterfall-card
        :data="sortedHealthData"
        :showHeader="false"
        :showLegend="true"
        title="营养素平均值动态图"
      ></waterfall-card> -->
      <!-- <div class="item-divider"></div> -->
      <!-- 营养素数据 -->
      <BodyReportCard
        :title="$t('titles.nutritionDataReport')" 
        :items="sortedHealthData"
        @item-click="handleNutritionItemClicks"
      />
    </div>
    <!-- 体质评估内容 -->
    <div v-if="activeTab === 'constitution'" class="chart-section">
      <!-- <waterfall-card
        :data="nzHealthData"
        :showHeader="false"
        :showLegend="true"
        title="身体内脏平均值动态图"
      ></waterfall-card>
      <div class="item-divider"></div> -->
      <BodyReportCard 
   :items="nzLists"
  @item-click="handleNutritionItemClick"
  :title="$t('titles.bodyOrgansDataReport')" 
/>

    </div>
    <!-- 身体评估内容 -->
    <div v-if="activeTab === 'body'" class="chart-section">

      <!-- <waterfall-card
        :data="zhHealthData"
        :showHeader="false"
        :showLegend="true"
        title="身体综合平均值动态图"
      ></waterfall-card>
      <div class="item-divider"></div> -->
      <BodyReportCard
      :title="$t('titles.bodyComprehensiveDataReport')" 
  :items="zhLists"
  @item-click="handleItemClick"
/>
      
    </div>
  </div>

  <!-- 动态变化图 -->
  <!-- <waterfall-card
        v-if="zhDynamics.length > 0" 
        title="身体综合检测动态图"
        :list="zhDynamics"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="stackValueKey"
        stack="diff"
    ></waterfall-card> -->

  <!-- 身体综合平均值状态图 -->
  <!-- <waterfall-card
        v-if="zhAverage.length > 0"
        title="平均值状态图"
        :list="zhAverage"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="avValueKey"
        colorKey="color"
    ></waterfall-card> -->

  <!-- 综合数据报告表 -->
  <!-- <table-card class="table" title="综合数据报告表" :columns="columns" :list="zhList" v-slot="row" tips @tip="interpret = true">
      <router-link :to="{ path: details[row.item_dict_type], query: { code: row.system_code, title: row.item_dict_name, color: row.color, ...query }}"></router-link>
    </table-card>

  

    身体内脏检测动态图
    <waterfall-card
        v-if="nzDynamics.length > 0"
        title="身体内脏检测动态图"
        :list="nzDynamics"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="stackValueKey"
        stack="diff"
    ></waterfall-card> -->

  <!-- 身体内脏平均值状态图 -->
  <!-- <waterfall-card
        v-if="nzAverage.length > 0"
        title="身体内脏平均值状态图"
        :list="nzAverage"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="avValueKey"
        colorKey="color"
    ></waterfall-card> -->

  <!-- 身体内脏数据报告表 -->
  <!-- <table-card class="table" title="身体内脏数据报告表" :columns="columns" :list="nzList" v-slot="row" tips @tip="interpret = true">
      <router-link :to="{ path: details[row.item_dict_type], query: { code: row.system_code, title: row.item_dict_name, color: row.color, ...query }}"></router-link>
    </table-card> -->

  <!-- 营养素检测动态图 -->
  <!-- <waterfall-card
        v-if="yyDynamics.length > 0"
        title="营养素检测动态图"
        :list="yyDynamics"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="stackValueKey"
        stack="diff"
    ></waterfall-card> -->

  <!-- 营养素平均值状态图 -->
  <!-- <waterfall-card
        v-if="yyAverage.length > 0"
        title="营养素平均值状态图"
        :list="yyAverage"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="avValueKey"
        colorKey="color"
    ></waterfall-card>

    营养素数据报告表 -->
  <!-- <table-card class="table" title="营养素数据报告表" :columns="columns" :list="yyList" v-slot="row" tips @tip="interpret = true">
      <router-link :to="{ path: details[row.item_dict_type], query: { code: row.system_code, title: row.item_dict_name, color: row.color, ...query }}"></router-link>
    </table-card> -->

  <!-- 解读说明弹窗 -->
  <!-- <dialog-view v-model="interpret" class="interpret" title="解读说明">
      <span v-for="(item, index) in levels" :key="index"><i :style="{background: item.color}"></i>{{item.str}}</span>
    </dialog-view> -->
</template>

<script>
// import WaterfallCard from "@/components/WaterfallCard";
// import TableCard from "@/components/TableCard";
import { getReportComprehensiveAll } from "../net/api";
// import NutritionVitalityCard from "../components/NutritionVitalityCard";
import BodyReportCard from "../components/BodyReportCard.vue";
// impo rt DialogView from "../components/DialogView";
import { routeLanguageMixin } from "@/utils/routeLanguageHelper";

export default {
  name: "Overview",
  mixins: [routeLanguageMixin],
  components: { BodyReportCard  },

  data() {
    return {
      packageNo: "",
      checkcode: "",
      rand: "",
      activeTab: "body", // 默认选中营养素评估标签页
      sortedHealthData: [],
      nzHealthData: [],
      zhHealthData:[],
      nzLists: [],
      zhLists: [],

      // 详情页路由地址
      details: ["", "", "/details", "/tissue", "/nutrition"],

      // 通用态图列表数据关联项
      statusValueKey: {
        av: "均值",
        one: "初值",
        two: "终值",
      },

      stackValueKey: {
        one: "初值",
        two: "终值",
      },

      avValueKey: {
        av: "均值",
      },

      // 综合动态图
      zhDynamics: [],
      // 内脏动态图
      nzDynamics: [],
      // 营养素动态图
      yyDynamics: [],

      // 综合平均值状态图
      zhAverage: [],
      // 内脏平均值状态图
      nzAverage: [],
      // 营养素平均值状态图
      yyAverage: [],

      // 综合数据表
      zhList: [],
      // 内脏数据表
      nzList: [],
      // 营养素数据表
      yyList: [],
      nutritionTabs: [],
      nutritionList: [],

      // 列表关联项
      columns: {},
      // 详细数据评估表
      list: [],

      // 报告等级列表
      levels: [],

      // 解读说明弹窗
      interpret: false,
      // 信息弹窗显示状态
      showInfoModal: false
    };
  },

  computed: {
    // 基础参数数据
    query() {
      return {
        packageNo: this.packageNo,
        rand: this.rand,
        checkcode: this.checkcode,
      };
    },

    // 国际化的列表关联项
    localizedColumns() {
      return {
        item_dict_name: this.$t('dataOverview.detectionItem'),
        one: this.$t('dataOverview.initialValue'),
        two: this.$t('dataOverview.finalValue'),
        diff: {
          name: this.$t('dataOverview.averageValue'),
          value: (row) => {
            let val = row.two - row.one;
            return (
              '<i class="arrow' +
              (val >= 0 ? " up" : "") +
              '" style="background-color: ' +
              row.color +
              ';"></i><label>' +
              this.formatNumber(row.av, 2) +
              "</label>"
            );
          },
        },
      };
    },

    // 国际化的营养标签页
    localizedNutritionTabs() {
      return [
        {
          name: this.$t('dataOverview.vitamins'),
          warningCount: 0,
          qualifiedCount: 0,
          items: [],
        },
        {
          name: this.$t('dataOverview.microelements'),
          warningCount: 0,
          qualifiedCount: 0,
          items: [],
        },
        {
          name: this.$t('dataOverview.minerals'),
          warningCount: 0,
          qualifiedCount: 0,
          items: [],
        },
      ];
    },

    // 国际化的默认营养列表
    localizedNutritionList() {
      return [
        {
          item_dict_name: this.$t('dataOverview.loadingText'),
          system_code: "",
          av: "...",
        },
      ];
    },
  },

  watch: {
    // 监听语言变化，更新国际化数据
    '$i18n.locale'() {
      this.columns = this.localizedColumns;
      this.nutritionTabs = this.localizedNutritionTabs;
      if (this.nutritionList.length === 1 && this.nutritionList[0].system_code === "") {
        this.nutritionList = this.localizedNutritionList;
      }
    },
  },

  created() {
    const query = this.$router.currentRoute.query;
    this.packageNo = query.packageNo;
    this.checkcode = query.checkcode;
    this.rand = query.rand;

    // 初始化国际化数据
    this.columns = this.localizedColumns;
    this.nutritionTabs = this.localizedNutritionTabs;
    this.nutritionList = this.localizedNutritionList;

    this.syncPageData();
  },

  methods: {
    // 格式化数值显示（国际化适配）
    formatNumber(value, decimals = 2) {
      if (value === null || value === undefined || value === '') {
        return '...';
      }
      
      const num = Number(value);
      if (isNaN(num)) {
        return value;
      }
      
      // 根据当前语言环境格式化数字
      const locale = this.$i18n.locale === 'en-US' ? 'en-US' : 'zh-CN';
      return num.toLocaleString(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
    },

    handleItemClick(item) {
      console.log(item);
      
      // 跳转到详情页
      this.navigateWithLanguage({
        path: "/details",
        query: {
          av: item.value || '',
          code: item.code || '',
          title: item.name,
          color: item.color || '',
          ...this.query
        }
      });
    },
     // 处理营养素项目点击
     handleNutritionItemClick(item) {
        // 跳转到营养素详情页
        this.navigateWithLanguage({
          path: '/nutrition',
          query: {
            code: item.code || '',  // 如果有code属性就使用，否则为空
            title: item.name,
            showDiet : 'true' ,
            av: item.av,
            ...this.query
          }
        });
      },
      handleNutritionItemClicks(item) {
        this.navigateWithLanguage({
          path: '/nutrition',
          query: {
            code: item.code || '',  // 如果有code属性就使用，否则为空
            title: item.name,
            av: item.value,
            ...this.query
          }
        });
        
      },
      
    // 营养数据排列
    processNutritionData() {
      if (!this.nutritionList || this.nutritionList.length === 0) return;

      // 假设前10个是维生素，接下来8个是微量元素，剩余的是矿物质
      const vitamins = this.nutritionList.slice(0, 10);
      const microelements = this.nutritionList.slice(10, 17);
      const minerals = this.nutritionList.slice(17, 26);

      // 转换数据格式
      const convertToTabFormat = (items) => {
        return items.map((item) => {
          // 假设item.av是一个-4到+4的值
          const value = parseFloat(item.av) || 0;
          return {
            name: item.item_dict_name,
            subname: item.item_dict_name_en || item.item_dict_name, // 如果有英文名就用英文名，否则用中文名
            value: value,
            code: item.system_code,
          };
        });
      };

      // 计算预警和合格项目数量
      const countWarningAndQualified = (items) => {
        let warningCount = 0;
        let qualifiedCount = 0;

        items.forEach((item) => {
          const value = parseFloat(item.av) || 0;
          if (value < 0) {
            warningCount++;
          } else {
            // 其他为合格项目
            qualifiedCount++;
          }
        });

        return { warningCount, qualifiedCount };
      };

      // 更新维生素标签页
      const vitaminStats = countWarningAndQualified(vitamins);
      this.nutritionTabs[0].items = convertToTabFormat(vitamins);
      this.nutritionTabs[0].warningCount = vitaminStats.warningCount;
      this.nutritionTabs[0].qualifiedCount = vitaminStats.qualifiedCount;

      // 更新微量元素标签页
      const microStats = countWarningAndQualified(microelements);
      this.nutritionTabs[2].items = convertToTabFormat(microelements);
      this.nutritionTabs[2].warningCount = microStats.warningCount;
      this.nutritionTabs[2].qualifiedCount = microStats.qualifiedCount;

      // 更新矿物质标签页
      const mineralStats = countWarningAndQualified(minerals);
      this.nutritionTabs[1].items = convertToTabFormat(minerals);
      this.nutritionTabs[1].warningCount = mineralStats.warningCount;
      this.nutritionTabs[1].qualifiedCount = mineralStats.qualifiedCount;

      console.log("处理后的营养标签页数据:", this.nutritionTabs);
    },
    // 同步页面数据
    syncPageData() {
      // 获取报告数据
      getReportComprehensiveAll({
        packageNo: this.packageNo,
        rand: this.rand,
        checkcode: this.checkcode,
      }).then((data) => {
        this.levels = data.colorData;
        this.zhDynamics = data.show_shenti_dongtaibianhua;
        this.nzDynamics = data.show_neizang_dongtaibianhua;
        this.yyDynamics = data.show_yingyang_dongtaibianhua;
        this.nutritionList = data.show_yingyang_xiangxishuju || [];
        this.zhAverage = data.show_shenti_zhuangtaitu;
        this.nzAverage = data.show_neizang_zhuangtaitu;
        this.yyAverage = data.show_yingyang_zhuangtaitu;
        this.processNutritionData();
        this.zhList = data.show_shenti_xiangxishuju;
        this.nzList = data.show_neizang_xiangxishuju;
        console.log("111",data.show_neizang_xiangxishuju);
        
        // this.yyList = data.show_yingyang_xiangxishuju;
        if (this.yyAverage && this.yyAverage.length > 0) {
          this.sortedHealthData = this.yyAverage.map((item) => ({
            name: item.item_dict_name,
            value: parseFloat(item.av) || 0,
            code: item.system_code,
            color: item.color,
            nameEn: item.item_dict_name_en || ''
          }));
        }
        if (this.nzAverage && this.nzAverage.length > 0) {
          this.nzHealthData = this.nzAverage.map((item) => ({
            name: item.item_dict_name,
            value: parseFloat(item.av) || 0,
          }));
          // // 可以根据需要对数据进行排序
          // this.nzHealthData.sort((a, b) => a.value - b.value);
          
        }
        if (this.zhAverage && this.zhAverage.length > 0) {
          this.zhHealthData = this.zhAverage.map((item) => ({
            name: item.item_dict_name,
            value: parseFloat(item.av) || 0,
            code: item.system_code,
          }));
          // // 可以根据需要对数据进行排序
          // this.zhHealthData.sort((a, b) => a.value - b.value);
        }
        if (this.nzList && this.nzList.length > 0) {
          this.nzLists = this.nzList.map((item) => ({
            name: item.item_dict_name,
            value: parseFloat(item.av) || 0,
            code: item.system_code,
            color: item.color,
            av: item.av,
          }));
          // // 可以根据需要对数据进行排序
          // this.nzLists.sort((a, b) => a.value - b.value);
        }
        if (this.zhList && this.zhList.length > 0) {
          this.zhLists = this.zhList.map((item) => ({
            name: item.item_dict_name,
            value: parseFloat(item.av) || 0,
            code: item.system_code,
          }));
          // 可以根据需要对数据进行排序
          // this.zhLists.sort((a, b) => a.value - b.value);
        }
      });
      

    },
  },
};
</script>

<style scoped>

.report-title{
  width: 300px;
  font-size: 30px;
  color: #333;
  text-align: justify;
  text-align-last: justify;
}

/* 英文版本优化 */
.report-title.english-title {
  text-align: left;
  text-align-last: left;
  white-space: nowrap;
  width: auto;
  min-width: 300px;
}
.report-title-2{
  width: 300px;
  text-align: justify;

}
.report-subtitle{
  font-size: 36px;
  color:#0F48C2;
  padding: 20px 0;
  font-weight: bold;
  line-height: 1.4;
}

/* 英文版本优化 */
.report-subtitle.english-subtitle {
  line-height: 1.8;
  padding: 25px 0;
}
.body-title{
  font-size: 30px;
  font-weight: bold;
  margin: 30px;
}
.body-title-subtitle {

  font-weight: 400;
  font-size: 23px;
  color: #A4A4A4;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.report-summary {
  width: 100%;
  background-color: #f5f5f5;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 30px;
  padding-bottom: 70px;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}

.report-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.report-text {
  //width: 290px;
}

.report-text h3 {
  font-weight: 400;
  font-size: 31px;
  color: #000000;
  line-height: 27px;
  letter-spacing: 20px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.report-text h2 {
  font-weight: 600;
  font-size: 40px;
  color: #0050ff;
  line-height: 31px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.report-text p {
  font-weight: 400;
  font-size: 19px;
  color: #959cc3;
  line-height: 27px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.report-content {
  margin-left:60px;
  font-weight: 400;
  font-size: 19px;
  color: #959cc3;
  line-height: 27px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}


.report-image {
  width: 200px;
  height: 200px;
  margin-right: 40px;
}

.report-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.tabs-container {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #e0e3f0;
  margin-top: 20px;
}
.chart-section {
  margin-top: 20px;
  min-height: 100vh;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 15px 0;
  font-size: 31px;
  color: #89899e;
  position: relative;
  cursor: pointer;
  font-weight: 500;
}

.tab-item.active {
  color: #0050ff;
  font-weight: 500;
}

.tab-item.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #0050ff;
}
.item-divider {
  width: 100%;
  height: 1px;
  background-color: #dfdfdf;
  margin: 15px 0;
}
.full-health-info-button-container {
  padding: 20px 30px;
  margin: 20px 0;
}
.full-health-info-button-container {
  padding: 20px 30px;
  margin: 20px 0;
}

.full-health-info-button {
  width: 100%;
  height: 90px;
  background-color: #0052d9;
  color: white;
  border: none;
  border-radius: 45px;
  font-size: 32px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 82, 217, 0.2);
  text-decoration: none;
  cursor: pointer;
}

/* 信息图标样式 */
.info-icon {
  width: 30px;
  height: 30px;
  margin-left: 15px;
  margin-bottom: 5px;
  cursor: pointer;
  vertical-align: middle;
}

/* 信息图片样式 */
.info-image {
  position: absolute;
  top: 320px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 600px;
  width: 90%;
  height: auto;
  border-radius: 10px;
  z-index: 100;
}
</style>
